import { render } from "./IconAddFile.vue?vue&type=template&id=6584fb5f"
import script from "./IconAddFile.vue?vue&type=script&lang=js"
export * from "./IconAddFile.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__